import { useQuery } from "@tanstack/react-query";
import { getUserInfoMe } from "../../../api/request/getUserInfoMe";
import { USER_QUERY_KEYS } from "../../constants";

export const useGetUserInfoMe = () => {
  const query = useQuery({
    queryKey: [USER_QUERY_KEYS.getUserInfoMe],
    queryFn: () => getUserInfoMe(),
    enabled: false,
  });

  return query;
};
